





import Vue from 'vue'

export default Vue.extend({
  name: 'AmataList',
  props: {
    type: {
      type: String,
      default: 'is-white'
    },
    striped: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssClass(): string {
      let classStr = ''
      if (this.type) {
        classStr += this.type
      }
      if (this.striped) {
        classStr += ' is-striped'
      }
      return classStr
    }
  }
})
